import {PermissionsInfo, type UserAttributes} from "@khan/shared-core";

export const canUserParticipateInABTesting = (
    userAttributes: UserAttributes | null,
) => {
    if (!PermissionsInfo.isLoggedIn) {
        return true;
    }
    return userAttributes?.canParticipateInABTesting;
};
